import React, { useEffect, useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    Card,
    CardBody,
    ListGroup,
    ListGroupItem,
    Button,
    Label,
} from "reactstrap";
import moment from "moment";
import { useFetch2 } from "components/utils/authenticatedHook";
import encryptRequest from "../../helpers/encryptationHelper";
import Select from "react-select";

function SendEducationalQuestionnaire({
    isModalOpen,
    toggleModal,
    selectedEducationMaterial,
    patientId,
}) {
    let [{ response: createEducationalQuestionnaire, error: createEducationalQuestionnaireError, isLoading: createEducationalQuestionnaireLoader }, doFetch2] = useFetch2();
    const [{ response, error, isLoading }, doFetch] = useFetch2();
    const [selectedId, setSelectedId] = useState(null);
    const [sentQuestionnaire, setSentQuestionnaire] = useState(false);

    // Find the selected questionnaire
    const selectedQ = response?.data?.find((q) => q._id === selectedId) || null;
    useEffect(() => {
        if (selectedEducationMaterial) {
            doFetch({
                url: `/get-send-educational-material-questionnaires/${encryptRequest(selectedEducationMaterial._id)}`,
                method: "GET",
                disableWait: true,
            });
        }
    }, [selectedEducationMaterial]);

    const handleConfirmSend = () => {
        setSentQuestionnaire(true);
        doFetch2({
            url: `/create-individual-educational-questionnaires/${encryptRequest(patientId)}/${encryptRequest(selectedQ._id)}`,
            method: "POST",
            disableWait: true,
            message: 'Questionnaire has been successfully sent to the patient'
        });
    };
    
    useEffect(() => {
        if(!createEducationalQuestionnaireLoader && sentQuestionnaire){
            toggleModal(); 
            setSelectedId(null);
            setSentQuestionnaire(false)
        }
    }, [createEducationalQuestionnaireLoader])
    return (
        <>
            <Modal isOpen={isModalOpen} toggle={() => { toggleModal(); setSelectedId(null)}} size={selectedQ ? "lg" : "md"}>
                <ModalHeader toggle={toggleModal} className="bg-light">
                    <i className="mdi mdi-file-document-outline mr-2 text-info"></i>
                    Questionnaire Details
                </ModalHeader>
                <ModalBody style={{ padding: "0rem" }}>
                    {(isLoading) ? (
                        <div
                            style={{
                                height: "40vh",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <div className="loader-container">
                                <div className="spinner"></div>
                            </div>
                        </div>
                    ) : (createEducationalQuestionnaireLoader) ? (
                    <div
                        style={{
                            height: "40vh",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        Please wait, we are sending questionnaire
                        <span style={{ display: "inline-block", marginLeft: "5px" }}>
                            <span className="dot">.</span>
                            <span className="dot">.</span>
                            <span className="dot">.</span>
                        </span>
                    </div>
                    ) : selectedEducationMaterial ? (
                        <Card className="shadow-sm border-0 rounded-lg">
                            <CardBody style={{ padding: "2rem" }}>

                                {/* Questionnaires Section */}
                                {response && response.data?.length > 0 ? (
                                    <div>
                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                            <Label className="mb-2" style={{fontSize : '0.9rem'}}>
                                                Select Questionnaire
                                            </Label>
                                            {selectedQ && (
                                                <Button
                                                    type="button"
                                                    title="Send Questionnaire"
                                                    color="info"
                                                    size="sm"
                                                    style={{ borderRadius: "10px" }}
                                                    onClick={handleConfirmSend}
                                                >
                                                    <i className="mdi mdi-send"></i> Send Questionnaire
                                                </Button>
                                            )}
                                        </div>
                                        <Select
                                            value={response.data.find(opt => opt._id === selectedId) || null}
                                            onChange={(option) => setSelectedId(option._id)} 
                                            options={response.data}
                                            getOptionLabel={option => option.name}
                                            getOptionValue={option => option._id}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: base => ({ ...base, zIndex: 9999 })
                                            }}
                                        />
                                        {selectedQ && (
                                            <Card className="shadow-sm border-0 rounded-lg mt-3">
                                                <CardBody style={{ padding: "1rem" }}>
                                                    {/* Title */}
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <h4 className="mb-3 text-info d-flex align-items-center">
                                                            <i className="mdi mdi-frequently-asked-questions mr-2"></i>
                                                            {selectedQ.name}
                                                        </h4>
                                                    </div>

                                                    {/* Meta Info */}
                                                    <div className="mb-3">
                                                        <p>
                                                            <strong>Created By:</strong>{" "}
                                                            {selectedQ.createdByUser
                                                                ? `${selectedQ.createdByUser.fname} ${selectedQ.createdByUser.lname} (${selectedQ.createdByUser.role})`
                                                                : "-"}
                                                        </p>
                                                        {selectedQ.repeatPer !== 'once' && (
                                                            <>
                                                                <p>
                                                                    <strong>Start Date:</strong>{" "}
                                                                    {moment(selectedQ.startDate).format("MMM DD, YYYY")}
                                                                </p>
                                                                <p>
                                                                    <strong>End Date:</strong>{" "}
                                                                    {moment(selectedQ.endDate).format("MMM DD, YYYY")}
                                                                </p>
                                                                 </>)}
                                                                <p>
                                                                    <strong>Frequency:</strong>{" "}
                                                                    <span>{selectedQ.repeatPer ? selectedQ.repeatPer.charAt(0).toUpperCase() + selectedQ.repeatPer.slice(1) : "-"}</span>
                                                                </p>
                                                           
                                                    </div>
                                                    <hr />

                                                    {/* Questions */}
                                                    <h5 className="mt-3 mb-3 text-info">
                                                        <i className="mdi mdi-help-circle-outline mr-2"></i>
                                                        Questions
                                                    </h5>

                                                    {selectedQ.questions?.length > 0 ? (
                                                        <ListGroup flush>
                                                            {selectedQ.questions.map((ques, idx) => (
                                                                <ListGroupItem key={ques._id} className="mb-2 rounded shadow-sm border">
                                                                    <strong className="d-block mb-2">
                                                                        Q{idx + 1}: {ques.question}
                                                                    </strong>

                                                                    {/* Options */}
                                                                    <ul className="mb-2 pl-3">
                                                                        {ques.answers.map((ans, i) => (
                                                                            <li
                                                                                key={i}
                                                                                style={{
                                                                                    color: ans.isCurrectAnswer ? "green" : "inherit",
                                                                                    fontWeight: ans.isCurrectAnswer ? "bold" : "normal",
                                                                                }}
                                                                            >
                                                                                {ans.answer}
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </ListGroupItem>
                                                            ))}
                                                        </ListGroup>
                                                    ) : (
                                                        <p className="text-muted">No questions available.</p>
                                                    )}
                                                </CardBody>
                                            </Card>
                                        )}
                                    </div>
                                ) : (
                                    <p className="text-muted">No questionnaire details available.</p>
                                )}
                            </CardBody>
                        </Card>
                    ) : (
                        <p>Loading...</p>
                    )}
                </ModalBody>
            </Modal>
        </>
    );
}

export default SendEducationalQuestionnaire;
